import React, { useState } from 'react'
import * as UIcons from '@iconscout/react-unicons'
import { FormProvider, useForm } from 'react-hook-form'
import Btn from 'components/Btn'
import { Menu } from 'assets/icons'
import { withTranslation } from 'react-i18next'
import { MenuItem } from '@mui/material'
import ReachAfrikaClickAway from './ReachAfrikaClickAway'
import { AiFillCloseSquare } from 'react-icons/ai'

export default withTranslation()(function HeaderWithExportOptions({ title, exportOptions, t }) {
  const method = useForm({
    mode: 'all'
  })

  // const { formState: {  } } = method;
  const [open, setOpen] = useState(false)
  const [showFilter, setShowFilter] = useState(false)
  const handleClick = () => { setOpen(!open) }

  return (
    <div className="w-full lg:flex justify-between p-3">
      <h3 className="text-xl font-semibold text-placeholder mb-5 lg:mb-0">{title}</h3>

      {/* <ClickAwayComponent 
        Component={forwardRef(({ handleClick, open }, ref) => <> */}
      <div className="w-full lg:w-[290px] flex justify-between relative" >

        <div className="w-1/5 order-2 relative">
          <Btn
            content={() => <><Menu classList="h-5" /></>}
            className={`w-10 h-10 border absolute right-0 rounded-lg ${open ? 'border-primary' : 'border-default'}`}
            click={handleClick}
            variant="outlined"
          />
        </div>

        {
          open ? <ReachAfrikaClickAway onClickAway={() => { setOpen(false); setShowFilter(false) }}>
            <ul className={`shadow-lg top-12 border w-[180px] right-1 absolute z-30 bg-white divide-y rounded-lg`}>
              {
                exportOptions && (
                  <>
                    {
                      exportOptions.map(({ name, Content, click }) => <React.Fragment key={name}>
                        {<MenuItem onClick={() => setShowFilter({click,content : <Content/>})}>{name}</MenuItem>}
                      </React.Fragment>
                      )
                    }
                  </>
                )
              }

              {
                open && showFilter?.click ?
                  <FormProvider {...method}>
                    <div className="w-[450px] rounded-md bg-white absolute -top-20 border right-0 z-[1000]">
                      <div className="w-full flex p-3 border-b">
                        <label className="w-full font-bold grow block capitalize">{showFilter?.click}</label>

                        <AiFillCloseSquare onClick={() => { setShowFilter(false) }} className="w-6 h-6 rounded bg-white cursor-pointer" />
                      </div>

                      <div className="grid grid-cols-2 gap-5 p-5">
                        {showFilter?.content}
                      </div>

                    </div>
                  </FormProvider> : null
              }
            </ul>
          </ReachAfrikaClickAway> : null
        }

        <form className="inline relative  order-1 w-4/5 overflow-hidden rounded-lg">
          <input type="text" name="search" className="bg-grey p-2 rounded-lg pl-10" placeholder={"Search"} />
          <UIcons.UilSearch className="text-placeholder absolute top-2 left-2 text-sm" />
        </form>
      </div>
    </div>
  )
})
